export interface SectionDwell {
  dwell_sec: number;
  visible?: boolean;
}

export interface EngagementScoreInput {
  totalDwellSec: number;
  imageViewCount: number;
  sections: Record<string, SectionDwell>;
  variantChanges: number;
  maxScrollDepth: number;
  addToCartClicked?: boolean;
}

/** Client-side engagement score (design doc §Engagement Score). */
export function computeEngagementScore(input: EngagementScoreInput): number {
  const desc = input.sections.description?.dwell_sec ?? 0;
  const reviews = input.sections.reviews?.dwell_sec ?? 0;

  let score =
    Math.min(input.totalDwellSec / 3, 30) +
    Math.min(input.imageViewCount * 5, 20) +
    Math.min(desc / 2, 15) +
    Math.min(reviews / 2, 10) +
    input.variantChanges * 5;

  if (input.maxScrollDepth >= 75) score += 10;
  if (input.addToCartClicked) score += 15;
  if (input.totalDwellSec < 5) score -= 20;

  return Math.max(0, Math.min(100, Math.round(score)));
}
